import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import addAddonInUseReducer from './reducer/addAddonInUseReducer';
import appendAddonsDataReducer from './reducer/appendAddonsDataReducer';
import increaseRequestedVersionReducer from './reducer/increaseRequestedVersionReducer';
import removeAddonInUseReducer from './reducer/removeAddonInUseReducer';
import setAddonsAttributionImageReducer from './reducer/setAddonsAttributionImageReducer';
import setAddonsDataReducer from './reducer/setAddonsDataReducer';
import setAddonsInUseReducer from './reducer/setAddonsInUseReducer';
import setRequestedVersionReducer from './reducer/setRequestedVersionReducer';
import setSearchValueReducer from './reducer/setSearchValueReducer';
import { AddonsState } from './types';

export const addonsInitialState: AddonsState = {
  inUse: [],
  requestedVersion: 0,
  loadingMore: false,
  data: {
    categoryId: 0,
    search: {
      value: '',
    },
    resultsVersion: 0,
    results: {},
    more: false,
  },
  attributionImage: undefined,
};

export const slice = createSlice({
  name: 'addons',
  initialState: addonsInitialState,
  reducers: {
    setAddonsInUseAction: setAddonsInUseReducer,
    addAddonInUseAction: addAddonInUseReducer,
    removeAddonInUseAction: removeAddonInUseReducer,
    setAddonsAttributionImageAction: setAddonsAttributionImageReducer,
    setSearchValueAction: setSearchValueReducer,
    setAddonsDataAction: setAddonsDataReducer,
    appendAddonsDataAction: appendAddonsDataReducer,
    increaseRequestedVersionAction: increaseRequestedVersionReducer,
    setRequestedVersionAction: setRequestedVersionReducer,
    setLoadingMoreAction: (state, action: PayloadAction<boolean>) => {
      state.loadingMore = action.payload;
    },
  },
});

export const {
  setAddonsInUseAction,
  addAddonInUseAction,
  removeAddonInUseAction,
  setAddonsAttributionImageAction,
  setSearchValueAction,
  setAddonsDataAction,
  appendAddonsDataAction,
  increaseRequestedVersionAction,
  setRequestedVersionAction,
  setLoadingMoreAction,
} = slice.actions;

export default slice.reducer;
